"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.takeCurrencySymbol = void 0;

var _currencySymbolMap = _interopRequireDefault(require("currency-symbol-map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the currency symbol from a given currency code. Uses currency-symbol-map internally.
 *
 * See: <a href="https://github.com/bengourley/currency-symbol-map#readme" target="_blank">currency-symbol-map</a>.
 *
 * @function takeCurrencySymbol
 * @memberof Formatters
 * @since 0.1.0
 *
 * @param {String} currencyCode
 *        case insensitive
 *
 * @returns {String}
 *          currency code is returned in uppercase if no suitable currency symbol to return
 *
 * @example
 *
 * takeCurrencySymbol("EUR");
 * // => "€"
 *
 * takeCurrencySymbol("czk");
 * // => "Kč"
 *
 * takeCurrencySymbol("PhP");
 * // => "₱"
 *
 * takeCurrencySymbol("hjkyuGD");
 * // => "HJKYUGD"
 */
var takeCurrencySymbol = function takeCurrencySymbol(currencyCode) {
  var codeUpperCase = currencyCode ? currencyCode.toUpperCase() : null;
  var symbol = (0, _currencySymbolMap.default)(codeUpperCase);
  return symbol ? symbol : codeUpperCase;
};

exports.takeCurrencySymbol = takeCurrencySymbol;
var _default = takeCurrencySymbol;
exports.default = _default;